import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import ServicesPreview from '../components/ServicesPreview';
import FeaturedSolutions from '../components/FeaturedSolutions';
import ProductsPreview from '../components/ProductsPreview';
import WhyBularis from '../components/WhyBularis';
import ContactCTA from '../components/ContactCTA';

const Home = () => {
return (
    <>
    <SEO
      title="Bularis Tech | Web, E-commerce & Automation"
      description="Web development, e-commerce, custom integrations and intelligent automation solutions for growing businesses."
      path="/"
    />
    <Hero />
    <ServicesPreview />
    <FeaturedSolutions />
    <ProductsPreview />
    <WhyBularis />
    <ContactCTA />
    </>
);
}

export default Home;
